import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { usernameSelector } from '../../auth/selectors/authSelectors';
import { editionSelector } from '../../users/selectors/userSelectors';
import { editionSelector as userGroupEditionSelector } from '../../groups/selectors/groupSelectors';
import Header from '../components/Header/Header';

const mapStateToProps = createStructuredSelector({
    username: usernameSelector,
    edition: editionSelector,
    userGroupEdition: userGroupEditionSelector
});

export default withRouter(
    connect(mapStateToProps, null)(Header)
);
